import NewEventCard from "components/NewEventCard"
import Image from "next/image"
import { motion } from "framer-motion"
import { useLang } from "hooks/useLang"
import { IFinalEvent } from "types/event"

const IMAGE_PLACEHOLDER =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEc9k2kuUxms3gQHFAHMBLUTjMSSGC-Zh2Ww&s"

interface ActivityCardProps {
    title: string
    images: string[]
    event: IFinalEvent
}

const ActivityCard = ({ title, images, event }: ActivityCardProps) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, ease: "easeIn" }}

            // className="flex flex-1 flex-col gap-4 justify-between rounded-[16px] bg-[#FFFFFFB2] p-5 backdrop-blur-sm"
        >
            {/* Title */}

            {/* Event */}
            {/* <NewEventCard event={event} /> */}

            {/* Images Grid — NOW ACTIVE */}
            <NewEventCard event={event} />
        </motion.div>
    )
}

interface ISpecialSectionProps {
    fromColor?: string
    img: string
    type: "single" | "multiple"
    title?: string
    events: IFinalEvent[] // must be array since you're mapping
    icon?: string
}

const SpecialSection = ({
    title,
    fromColor = "transparent",
    img,
    type,
    events,
    icon,
}: ISpecialSectionProps) => {
    const { t } = useLang()

    console.log({ icon })

    const cardImages =
        type === "multiple"
            ? Array.from({ length: 4 }, () => IMAGE_PLACEHOLDER)
            : [IMAGE_PLACEHOLDER]
    console.log()
    return (
        <div
            className="w-full mt-[50px] md:mt-[200px] mb-[25px] px-5 md:px-0"
            style={{
                background: `linear-gradient(to bottom, ${fromColor}, transparent)`,
            }}
        >
            <div className="flex flex-col items-center justify-between gap-6 sm:gap-8 w-full max-w-[1220px] mx-auto sm:p-6">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row gap-4 sm:gap-8 w-full items-start">
                    <div className="flex flex-col w-full md:w-3/5 text-center md:text-left py-5 md:py-0 gap-4">
                        <span className="md:text-2xl text-[18px] font-bold uppercase text-start">
                            {title ?? t("winter_season_is_here")}
                        </span>

                        <span className="md:text-[3rem] text-[28px]  font-bold uppercase leading-tight text-start">
                            {t("explore_what's_happening_around_you")}
                        </span>
                    </div>

                    <div className="hidden md:flex flex-col items-center w-full md:w-2/5 -mt-[150px]">
                        <Image
                            src={icon || ""}
                            alt="Decoration"
                            width={355}
                            height={355}
                            className="w-[200px] sm:w-[280px] lg:w-[355px] h-auto"
                            style={{ zIndex: 80 }}
                        />
                    </div>
                </div>

                {/* Cards Section */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3   gap-[20px] w-full">
                    {events?.map((event, index: number) => (
                        <ActivityCard
                            key={event._id ?? index}
                            event={event}
                            title="night_out_with_friends"
                            images={cardImages}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default SpecialSection
